import React, { Fragment } from "react";
import { Box, Card, CardContent, Tab, Tabs, Typography } from "@mui/material";
import { TAB } from "../utils/ComponentList";

export default function SaitTabs(props) {
	const [choosenTab, setChoosenTab] = React.useState(0);
	const defaultColumnWidth = 500;
	const handleChangeTab = (event, newValue) => {
		setChoosenTab(newValue);
	};

	const returnParagraph = (paragraph, index) => {
		return (
			<Box
				key={index}
				sx={{
					alignItems: paragraph.flexDirection === "column" ? "center" : null,
					flex: 1,
				}}
			>
				{props.noCard ? (
					<Box
						sx={{
							flex: 1,
							flexDirection: "column",
							display: "flex",
							height: "100%",
						}}
					>
						<Typography variant="h5">{paragraph.title}</Typography>
						{!paragraph.hidden && paragraph.content}
					</Box>
				) : (
					<Card
						key={index}
						sx={{
							flex: 1,
							display: "flex",
							height: "100%",
							m: 1,
							width: paragraph.flexDirection === "column" ? paragraph.width || defaultColumnWidth : paragraph.width || null,
						}}
						elevation={5}
					>
						<CardContent
							sx={{
								flex: 1,
								display: "flex",
							}}
						>
							<Typography variant="h5">{paragraph.title}</Typography>
							{!paragraph.hidden && paragraph.content}
						</CardContent>
					</Card>
				)}
			</Box>
		);
	};

	return (
		<Box sx={{ height: "100%", flex: 1, flexDirection: "column", display: "flex" }}>
			{/* Inserisco i Titoli delle Tabs, se ce n'è almeno una */}
			{props.fields.some((item) => item.type === TAB) && (
				<Box sx={{ borderBottom: 1, borderColor: "divider" }}>
					<Tabs sx={props.tabsSx} value={choosenTab} onChange={handleChangeTab} centered={props.centeredTabs || false}>
						{props.fields.map((element, index) => !element.hidden && element.type === TAB && <Tab sx={props.tabsSx} key={index} label={element.title} />)}
					</Tabs>
				</Box>
			)}
			<Box
				sx={{
					flex: 1,
					display: "flex",
				}}
			>
				{props.fields.map(
					(element, index) =>
						!element.hidden &&
						element.type === TAB && (
							<Fragment key={index}>
								{index === choosenTab && element.items.map((childElement, indexChildElement) => !childElement.hidden && returnParagraph(childElement, indexChildElement))}
							</Fragment>
						)
				)}
			</Box>
		</Box>
	);
}
